export const iconFontAwesomeArrowsTurnDown = (
	<i className="fa-solid fa-turn-down"></i>
);
